export default ({ status, statusList }) =>
  status ? status.value : statusList[0].value;



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/helpers/get-status-value.js